import { doc, runTransaction, serverTimestamp, Timestamp } from 'firebase/firestore';
import { db } from '../../../shared/storage/firebase';
import type { PartnerSeason, PartnerSeasonMarketingDeliverable } from '../types';
import { seasonMarketingDeliverables, validateMarketingItem } from '../utils/partnerMarketing';

export async function savePartnerMarketing(params: {
  partnerId: string; seasonId: string; termId: string; label: string; actorId: string;
  item?: PartnerSeasonMarketingDeliverable; notes?: string;
}): Promise<void> {
  const { partnerId, seasonId, termId, label, actorId, item, notes } = params;
  if (!partnerId || !seasonId || !termId || !actorId) throw new Error('Sign in and select a partner season.');
  if (notes && notes.length > 100_000) throw new Error('These notes are too long. Link to the full document instead.');
  if (item) {
    const error = validateMarketingItem(item);
    if (error) throw new Error(error);
  }
  const ref = doc(db, 'partners', partnerId, 'seasons', seasonId);
  await runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(ref);
    const existing = snapshot.exists() ? snapshot.data() as PartnerSeason : null;
    const marketing = { ...existing?.marketing };
    if (item) {
      const items = seasonMarketingDeliverables(existing);
      const previous = items.find((entry) => entry.id === item.id);
      // Array entries cannot contain serverTimestamp sentinels.
      const now = Timestamp.now();
      const updated = { ...previous, ...item, createdAt: previous?.createdAt || now, createdBy: previous?.createdBy || actorId, updatedAt: now, updatedBy: actorId };
      marketing.deliverables = previous ? items.map((entry) => entry.id === item.id ? updated : entry) : [...items, updated];
    }
    if (notes !== undefined) marketing.notes = notes;
    if (new Blob([JSON.stringify(marketing)]).size > 750_000) throw new Error('This season has reached its marketing storage limit. Your changes have not been saved; use links for large documents.');
    // Patch only marketing. Preserve concurrent commitment and calendar changes.
    if (snapshot.exists()) transaction.update(ref, { marketing, updatedAt: serverTimestamp(), updatedBy: actorId });
    else transaction.set(ref, { partnerId, termId, label, marketing, createdAt: serverTimestamp(), createdBy: actorId, updatedAt: serverTimestamp(), updatedBy: actorId });
  });
}
